import { createFileRoute } from "@tanstack/react-router";
import { TrendingUp, Rocket, Home, Building2 } from "lucide-react";
import { PlatformHub } from "@/components/marketing/PlatformHub";
import heroImg from "@/assets/networking.jpg";

export const Route = createFileRoute("/solutions/")({
  head: () => ({
    meta: [
      { title: "Solutions by Team — Sales, Founders, Real Estate & Enterprise | Banana" },
      { name: "description", content: "Banana tuned for the way your team actually works — sales, founders, real estate and enterprise. Pick your playbook." },
      { property: "og:title", content: "Solutions by Team — Sales, Founders, Real Estate & Enterprise | Banana" },
      { property: "og:description", content: "Sales teams, founders, real estate, enterprise — see how Banana fits your motion." },
      { property: "og:image", content: heroImg },
      { property: "og:url", content: "https://banana.cards/solutions" },
    ],
    links: [{ rel: "canonical", href: "https://banana.cards/solutions" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Solutions by Team — Sales, Founders, Real Estate & Enterprise",
          description: "Banana tuned for the way your team actually works — sales, founders, real estate and enterprise.",
          url: "https://banana.cards/solutions",
          isPartOf: { "@type": "WebSite", name: "banana.cards", url: "https://banana.cards" },
        }),
      },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <PlatformHub
      eyebrow="Solutions"
      title="Built for the way"
      italic="your team actually works."
      description="The same Banana platform, tuned to four specific motions. Pick the one closest to you — we'll show you the exact stack of cards, CRM and apps that fits."
      heroImage={heroImg}
      features={[
        {
          title: "For Sales Teams",
          desc: "Win more deals in less time. Capture every lead in seconds, automate follow-up, and keep the pipeline honest.",
          href: "/solutions/sales",
          icon: TrendingUp,
          bullets: ["Instant lead capture", "AI follow-up drafts", "Pipeline that updates itself"],
        },
        {
          title: "For Founders",
          desc: "Never lose a connection again. Your second brain for every coffee, conference and intro.",
          href: "/solutions/founders",
          icon: Rocket,
          bullets: ["AI memory per contact", "Smart reminders", "One profile, every channel"],
        },
        {
          title: "For Real Estate",
          desc: "Stay top of mind with every client. Listings, bookings and reviews on a card you tap to share.",
          href: "/solutions/real-estate",
          icon: Home,
          bullets: ["Bookings on your card", "Review automation", "Listing & contact capture"],
        },
        {
          title: "For Enterprise",
          desc: "SSO, security, and seat-based billing. Roll out branded cards to thousands in a day.",
          href: "/solutions/enterprise",
          icon: Building2,
          bullets: ["SAML SSO & SCIM", "Branded templates at scale", "Audit logs & DPA"],
        },
      ]}
      outro={{ title: "Not sure which fits?", italic: "Let's talk.", description: "Tell us how your team moves and we'll map Banana to it in 15 minutes." }}
    />
  );
}